var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotebook16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.25 15C2.56 15 2 14.44 2 13.75v-11c0-.69.56-1.25 1.25-1.25h9c.966 0 1.75.784 1.75 1.75v10A1.75 1.75 0 0112.25 15h-9zm9-12H6.5v10.5h5.75a.25.25 0 00.25-.25v-10a.25.25 0 00-.25-.25zM5 3H3.5v10.5H5V3zm5.5 7.5a.75.75 0 01.102 1.493L10.5 12h-2a.75.75 0 01-.102-1.493L8.5 10.5h2zm0-3a.75.75 0 01.102 1.493L10.5 9h-2a.75.75 0 01-.102-1.493L8.5 7.5h2zm-1-3a.75.75 0 01.102 1.493L9.5 6h-1a.75.75 0 01-.102-1.493L8.5 4.5h1z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75 14.25v-12h-2.5a.5.5 0 00-.5.5v11a.5.5 0 00.5.5h2.5z",
    fillOpacity: 0.15
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebook16);
export default __webpack_public_path__ + "static/media/notebook-16.e1e85ebb.svg";
export { ForwardRef as ReactComponent };